import { render, staticRenderFns } from "./DialogImportIndexTeamLead.vue?vue&type=template&id=8d828060"
import script from "./DialogImportIndexTeamLead.vue?vue&type=script&lang=js"
export * from "./DialogImportIndexTeamLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports